// packages
import { bbox as getBbox, feature, mesh } from 'topojson-client';

export function prepareTopojson(topology, keys) {
  if (!Array.isArray(keys)) {
    keys = [keys];
  }

  return keys.map((key) => feature(topology, key));
}

export function getGeoJsonFromTopoJson(
  topology,
  key,
  { innerlines = false, outerlines = false } = {}
) {
  const object = topology.objects[key];
  const bbox = topology.bbox ? topology.bbox : getBbox(topology);

  return {
    collection: feature(topology, object),
    bbox,
    innerlines: innerlines
      ? mesh(topology, object, (a, b) => a !== b)
      : undefined,
    outerlines: outerlines
      ? mesh(topology, object, (a, b) => a === b)
      : undefined,
  };
}
